var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowMobileInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.54065 5.64333L10.7782 1.39833C10.8484 1.32861 10.9042 1.24566 10.9423 1.15426C10.9804 1.06287 11 0.964838 11 0.865829C11 0.76682 10.9804 0.668791 10.9423 0.577396C10.9042 0.486002 10.8484 0.403051 10.7782 0.333329C10.6376 0.193641 10.4475 0.115234 10.2494 0.115234C10.0513 0.115234 9.86117 0.19364 9.72065 0.333329L5.97065 4.04583L2.25815 0.333328C2.11763 0.19364 1.92754 0.115234 1.7294 0.115234C1.53126 0.115234 1.34117 0.19364 1.20065 0.333328C1.12978 0.402789 1.07341 0.485623 1.03478 0.57703C0.996162 0.668436 0.976064 0.766598 0.975652 0.865828C0.976064 0.965059 0.996162 1.06322 1.03478 1.15463C1.07341 1.24603 1.12978 1.32887 1.20065 1.39833L5.43815 5.64333C5.50838 5.71946 5.59362 5.78021 5.6885 5.82177C5.78337 5.86332 5.88582 5.88478 5.9894 5.88478C6.09298 5.88478 6.19543 5.86332 6.29031 5.82177C6.38518 5.78021 6.47042 5.71946 6.54065 5.64333Z",
    fill: "#E1E4ED"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMobileInput);
export default __webpack_public_path__ + "static/media/arrow_mobile-input.a0b0a2925fdf96d2caaedaff8bc634e0.svg";
export { ForwardRef as ReactComponent };